import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Winners from '../views/Winners';
// import authFlow from '../modules/authFlow';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/winners',
    name: 'Winners',
    component: Winners,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
      }
    }
  }
});

export default router;
